<script setup lang="ts">
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons';
import { type BreadcrumbItem } from './types';
interface IProps {
    items?: BreadcrumbItem[];
    theme?: 'dark' | 'light';
}
const { items = [], theme = 'dark' } = defineProps<IProps>();
const route = useRoute();
// this never work i think
useSchemaOrg([
    defineBreadcrumb({
        '@context': 'https://schema.org',
        '@id': `https://mrbilit.com${route.path.replace(/\/$/, '')}#breadcrumb`,
        '@type': 'BreadcrumbList',
        itemListElement: (items ?? []).map((item, index) => ({
            '@type': 'ListItem',
            item: item.link,
            name: item.title,
            position: index + 1,
        })),
    }),
]);
</script>
<template>
    <nav class="breadcrumb-root">
        <component
            :is="index !== items.length - 1 ? 'a' : 'div'"
            v-for="(item, index) in items || []"
            :key="index"
            :href="item.link"
            class="breadcrumb-item"
        >
            <span
                class="title"
                :class="[theme, { active: index === items.length - 1 }]"
            >
                {{ item.title }}
            </span>
            <mr-icon
                v-if="index !== items.length - 1"
                :icon="faAngleLeft"
                size="small"
                :color="
                    theme === 'dark' ? 'var(--gray-700)' : 'var(--blue-200)'
                "
            />
        </component>
    </nav>
</template>

<style lang="scss" scoped>
.breadcrumb-root {
    display: flex;
    align-items: center;
    padding-block: 8px;
    overflow-y: auto;
    max-width: 100vw;
    padding-inline: 8px;
    @include no-scrollbar;
    .breadcrumb-item {
        display: flex;
        align-items: center;
        gap: 4px;
        text-decoration: none;
        .title {
            white-space: nowrap;
            &.dark.active {
                @include tg-l;
            }
            &.dark:not(.active) {
                @include tg-l($color: usePalette($p-gray, $p-700));
            }
            &.light.active {
                @include tg-l($color: white);
            }
            &.light:not(.active) {
                @include tg-l($color: usePalette($p-blue, $p-200));
            }
        }
    }
}
</style>
